.screen {
  position: relative;
  max-width: 440px;
  margin: 0 auto;
  min-height: 100dvh;
}
.bar {
  display: flex;
  justify-content: flex-end;
  gap: var(--dimension-space-2);
  padding: var(--dimension-space-2) var(--gutter) 0;
}
.round {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: var(--dimension-radius-capsule);
  border: var(--dimension-line-hairline) solid var(--color-border-hairline);
  background: var(--color-surface-raised);
  color: var(--color-text-primary);
  cursor: pointer;
}
.round svg {
  width: 20px;
  height: 20px;
}
.plate {
  display: grid;
  gap: var(--dimension-space-3);
  padding-bottom: 6rem;
}
.header {
  display: grid;
  gap: var(--dimension-space-1);
  padding: 0 var(--gutter);
}
.kicker,
.weather {
  color: var(--color-text-tertiary);
}
.strip {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--dimension-space-1) var(--dimension-space-2);
  margin: 0;
  font: inherit;
}
.flagGroup {
  display: inline-flex;
  align-items: center;
  gap: var(--dimension-space-2);
}
.muted {
  color: var(--color-text-secondary);
}
.weather {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-2);
  margin: var(--dimension-space-1) 0 0;
}
.weather svg {
  width: 0.875rem;
  height: 0.875rem;
  flex: none;
}

.map {
  position: relative;
  height: 212px;
  background: var(--color-surface-sunken);
  border-block: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.mapTopLeft {
  position: absolute;
  left: var(--dimension-space-2);
  top: var(--dimension-space-2);
}
.mapBottomRight {
  position: absolute;
  right: var(--dimension-space-2);
  bottom: var(--dimension-space-2);
}

.ruler {
  position: relative;
  height: 34px;
  margin: 0 var(--gutter);
}
.base {
  position: absolute;
  inset: 13px 0 auto;
  height: 1px;
  background: var(--color-border-hairline);
}
.block {
  position: absolute;
  top: 4px;
  height: 9px;
  border: 1px solid var(--color-text-primary);
  background: var(--color-surface-base);
}
.done {
  background: var(--color-text-primary);
}
.now {
  position: absolute;
  top: 0;
  width: 2px;
  height: 17px;
  margin-left: -1px;
  background: var(--color-text-primary);
}
.now::after {
  content: "";
  position: absolute;
  top: -3px;
  left: -3px;
  width: 8px;
  height: 8px;
  background: var(--color-accent-indicator);
  box-shadow: 0 0 0 1px var(--color-text-primary);
}
.ticks {
  position: absolute;
  inset: 19px 0 auto;
  color: var(--color-text-tertiary);
  /* A chart: hour labels keep their size; the label above carries the data. */
  font-size: 11px;
}
.tick {
  position: absolute;
  transform: translateX(-50%);
}

.booking {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: var(--dimension-space-3);
  margin: 0 var(--gutter);
  padding: 10px var(--dimension-space-3);
  background: var(--color-surface-raised);
  border: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.bookingChip {
  display: grid;
  place-items: center;
  width: 1.375rem;
  height: 1.375rem;
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
}
.bookingChip svg {
  width: 0.75rem;
  height: 0.75rem;
}
.bookingText {
  display: grid;
  gap: var(--dimension-space-1);
}
.bookingTitle {
  margin: 0;
  font-weight: 700;
}
.stop {
  color: var(--color-text-tertiary);
}

.items {
  border-top: var(--dimension-line-hairline) solid var(--color-border-hairline);
  padding-right: var(--gutter);
}

.log {
  position: fixed;
  right: max(var(--gutter), calc(50% - 220px + var(--gutter)));
  bottom: var(--dimension-space-6);
}
